module.exports = __webpack_public_path__ + "img/kjBanner5.39281064.jpg";